var React = require('react');

function FormEmail (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#ed7808;}")),React.createElement("g",{"id":"Capa_2","data-name":"Capa 2","key":1},React.createElement("g",{"id":"Capa_1-2","data-name":"Capa 1"},React.createElement("path",{"className":"cls-1","d":"M11.1,15.74H2.18a2.19,2.19,0,0,1-1.34-.36A2,2,0,0,1,0,13.66V2.07a2,2,0,0,1,1.51-2A2.81,2.81,0,0,1,2.16,0H20.24a2,2,0,0,1,2.07,1.46,2.79,2.79,0,0,1,.07.64V13.67a1.93,1.93,0,0,1-1.5,2,2.65,2.65,0,0,1-.69.07ZM2.28,1.34l.15.16L9.82,8.84a2,2,0,0,0,2.85-.1l7.26-7.22.17-.18Zm.1,13.07H20l-5.5-5.59-.94.94A3.25,3.25,0,0,1,9,9.85c-.36-.33-.67-.72-1-1.11Zm-1-12.18V13.51L6.86,7.87ZM21.05,13.52V2.24L15.53,7.87Z"})))]);
}

FormEmail.defaultProps = {"viewBox":"0 0 22.38 15.74"};

module.exports = FormEmail;

FormEmail.default = FormEmail;
